export const selectField = [
    {
        name: "accountNumber",
        label: "Account Number",
    },
    { name: "region", label: "Region", },
    { name: "service", label: "Service", },
]


export const textFields = [
    { name: "name", label: "Name" },
    { name: "description", label: "Description" },
]
export const vpcEnabledServices = [
    "alb",
    "application-auto-scaling",
    "asg",
    "ec2_instance",
    "ecs",
    "efs",
    "eks",
    "lambda",
    "rds/mysql",
    "rds/postgres",
    "aurora/mysql",
    "aurora/postgresql",
    "redis",
    "redshift",
    "sg"
]
export const vpcFormFields = [
    { name: "vpc", label: "VPC" },
    { name: "subnets", label: "Subnet" },
]

export const hasSingleSubnet = (service) => {
    const singleSubnetServices = ['ec2_instance']
    return singleSubnetServices.includes(service)
}
